<template>
  <div class="container mx-auto px-4 py-8">
    <div class="bg-white rounded-lg shadow-md p-6">
      <p>Set your app language here</p>
      <div id="google_translate_element" class="block"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line
      new window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    }, 2000);
  }
};
</script>

<style></style>
